import { companydropdown, hidedropdown } from "../blocks/companies-accordion";

export var loadmore = function() {

    const button = document.getElementById('loadmore');
    bindEvent();

    function bindEvent() {
        button && button.addEventListener('click', clickHandle)
    }

    function clickHandle(e) {
        const button = e.target;
        //console.log(dayshift_loadmore_params.query_vars, 'before load more');
        $.ajax({
            url: dayshift_loadmore_params.ajaxurl,
            data: {
                'action' : 'loadmore',
                'query_vars' : dayshift_loadmore_params.query_vars,
                'page' : dayshift_loadmore_params.current_page
                // 'params' : dayshift_loadmore_params.allTheFilters
            },
            type: 'POST',
            beforeSend : function() {
                button.innerHTML = "Loading...";
            },
            error : function() {
                console.log('error');
            },
            success : function( data ) {
                console.log('success 1: data = ' + data);
                if ( data ) {

                    button.innerHTML = "Load More" + `<svg xmlns="http://www.w3.org/2000/svg" width="13.955" height="16.465" viewBox="0 0 13.955 16.465">
                <g id="Group_36" data-name="Group 36" transform="translate(12.443 -1.963) rotate(90)">
                    <path id="Vector_3_Stroke_" data-name="Vector 3 (Stroke)" d="M0,.813A.755.755,0,0,1,.681,0H14.935a.756.756,0,0,1,.681.813.756.756,0,0,1-.681.813H.681A.755.755,0,0,1,0,.813Z" transform="translate(1.963 4.653)"/>
                    <path id="Rectangle_2_Stroke_" data-name="Rectangle 2 (Stroke)" d="M0,.813A.813.813,0,0,1,.813,0H8.648A1.219,1.219,0,0,1,9.867,1.219V9.055a.813.813,0,0,1-1.625,0V1.625H.813A.813.813,0,0,1,0,.813Z" transform="translate(11.45 -1.512) rotate(45)"/>
                </g>
            </svg>`;
                    // console.log(data, 'data');

                    // if companies
                    if($('body').hasClass('page-template-companies-page')) {
                        $("tr.accordion").unbind('click');
                        $('#companies_table tbody').append(data);
                        hidedropdown();
                        companydropdown();
                    } else {
                        $('#postsContainer.post-roll-grid').append(data);
                        console.log('in the else');
                    }
                    
                    dayshift_loadmore_params.current_page++;
                    // console.log(dayshift_loadmore_params.current_page);
                    // console.log(dayshift_loadmore_params.max_page);

                    if (dayshift_loadmore_params.current_page == dayshift_loadmore_params.max_page) {
                        $('button#loadmore').addClass('hide');
                        $('table#companies_table').css('margin-bottom', '75px');
                    } else {
                        $('button#loadmore').removeClass('hide');
                    }
            }
        }
    })
};
};